import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Toolbar } from 'primereact/toolbar';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import moment from 'moment';
import { getAllDetailsDirect } from '../../../service/ProductService';
import { GET_OUTWARD_LIST } from '../../../config/ApiConstant';
import { InwardRegisterListColumns, OutwardRegisterListColumns } from '../../../appconfig/DatatableSetting';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { EntDtTemplate } from '../../../appconfig/DatatableTemplateSetting';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const OutwardRegisterList = () => {
    document.title = 'Outward Registration | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('outwardreg_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();
    const [searchVal, setSearchVal] = useState<any>("");

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [outwardList, setOutwardList] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getAllOutwardList();
    }, [dates]);

    // Get all outward list
    const getAllOutwardList = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetailsDirect(GET_OUTWARD_LIST + '?start_date=' + startDate + '&end_date=' + endDate + '&search=' + searchVal);
            if (response) {
                setPageLoad(true);
                setOutwardList(response.list);
            }
        } catch (error: any) {
            setPageLoad(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'outwardreg_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="block mt-2 md:mt-0 p-input-icon-left mr-3">
                    <i className="pi pi-search"></i>
                    <InputText value={searchVal} onChange={(e) => setSearchVal(e.target.value)} placeholder="Search..." className="" />
                    <i className="pi pi-times input-s" onClick={() => removeSearch()} style={{ right: '10px', zIndex: '111111', cursor: 'pointer' }}></i>
                </span>
                <Button label="" icon="pi pi-search" className="p-button p-button-rounded mr-3" onClick={() => getAllOutwardList()} />
            </>
        );
    };

    const removeSearch = () => {
        getAllOutwardList();
        setSearchVal("");
        setGlobalFilter(null);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />

                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
    };

    // Template for ToAddress
    const ToAddressTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <Button tooltip={rowData?.ToAddress} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{!window.cn(rowData.ToAddress) ? rowData.ToAddress : ''}</div>
                </Button>
            </>
        );
    };

    // Template for main_type
    const MainTypeTemplate = (rowData: any, rowIndex: any) => {
        return <>{rowData?.main_type?.Data}</>;
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'In-Out Register'} pageName={'Outward Registration'} goToPage={true} pageTitle={'Outward Registration'} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={outwardList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={outwardList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Outward Found"
                                >
                                    {OutwardRegisterListColumns.map((col, i) => {
                                        if (col.field === 'EntDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={EntDtTemplate} />;
                                        } else if (col.field === 'ToAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={ToAddressTemplate} />;
                                        } else if (col.field === 'main_type') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={MainTypeTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {OutwardRegisterListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
